<template>
  <div
    v-if="timeToEnd !== undefined"
    class="timeToEnd"
  >
    <v-btn
      variant="plain"
      disabled
    >
      {{ timeToEnd?.minutes }}:{{ timeToEnd?.seconds }}
    </v-btn>
  </div>
</template>

<script lang="ts" setup>
  import { onMounted, onUnmounted, ref } from 'vue';
  import keycloak from '@/plugins/keycloak';

  interface TimeToEnd {
    total: number;
    minutes: number;
    seconds: number;
  }

  const timeToEnd = ref<TimeToEnd | undefined>(calculateTimeToEnd());

  function calculateTimeToEnd(): TimeToEnd | undefined {
    let targetDate = undefined;
    if (keycloak && keycloak.idTokenParsed && keycloak.idTokenParsed.exp) {
      targetDate = new Date(keycloak.idTokenParsed.exp * 1000);
    }

    if (targetDate) {
      const total = targetDate?.getTime() - new Date().getTime();
      const seconds =
        Math.floor((total / 1000) % 60) < 10
          ? '0' + Math.floor((total / 1000) % 60)
          : Math.floor((total / 1000) % 60);
      const minutes = Math.floor((total / 1000 / 60) % 60);
      return {
        total,
        minutes,
        seconds,
      };
    } else {
      return undefined;
    }
  }

  let interval: number;
  onMounted(() => {
    interval = window.setInterval(() => {
      timeToEnd.value = calculateTimeToEnd();
    }, 1000);
  });

  onUnmounted(() => {
    clearInterval(interval);
  });
</script>

<style lang="scss" scoped>
  .timeToEnd {
    color: white !important;
    display: block;
    text-align: center;
  }
</style>
